import { render } from "./PalletTypes.vue?vue&type=template&id=0a8bdccd"
import script from "./PalletTypes.vue?vue&type=script&lang=ts"
export * from "./PalletTypes.vue?vue&type=script&lang=ts"
script.render = render

export default script